module.exports = require("babel-runtime/core-js/map");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/map"
// module id = 29
// module chunks = 0